let more = true;
let category = "";
let page = 1;
let maxPage = 0;
$(function () {
    maxPage = $("#rd_news_max_page").data("page");

    $(".wrap_select")
        .find(".drop_button")
        .on("click", function () {
            $(".wrap_select").find(".drop_menu").fadeToggle();
        });

    if ($("#rd-section-abl1").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-abl1",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-abl1").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-abl2").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-abl2",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-abl2").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-abl3").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-abl3",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-abl3").addClass("ani_do").removeClass("op0");
            },
        });
    }

    $(".rd_category").on("click", function () {
        $("#rd_category_name").text($(this).text());
        $("#rd_drop_menu").hide();
        category = $(this).data("id");
        page = 0;
        more = true;
        maxPage = $(this).data("page");
        if (maxPage > 1) {
            $("#rd_more").show();
        }
        $("#rd-section-abl2").html("");
        newsMore();
    });

    $("#rd_more").on("click", function () {
        newsMore();
    });
});

function newsMore() {
    if (more) {
        $("#rd_loading").show();
        more = false;
        page++;
        $.ajax({
            type: "GET",
            url: $("#rd_more_url").data("url"),
            data: `category=${category}&page=${page}`,
            cache: false,
            success: function (response) {
                $("#rd-section-abl2").append(response);
                $("#rd_loading").hide();
                if (page == maxPage) {
                    $("#rd_more").hide();
                } else {
                    more = true;
                }
            },
            error: function (e) {
                $("#rd_more").hide();
                $("#rd_loading").hide();
            },
        });
    }
}
